import { Text } from "@core/index";
import { Button } from "@core/button";
import { useLocalStorage } from "@packages/hooks/useLocalStorage";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "@packages/store/hooks";
import { useLocation } from "react-router-dom";

const EdlinkReminder = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [isDismissed, setIsDismissed] = useLocalStorage(
    "edlink-reminder-dismissed",
    false,
  );

  const teacherId = useAppSelector((state) => state.user.teacher?.id);

  const isEdlinkUser = useAppSelector(
    (state) => !!state.user.teacher?.edlinkPersonId,
  );

  const isEdlinkConnected = useAppSelector(
    (state) => !!state.user.teacher?.hasActiveEdlinkToken,
  );

  if (
    isDismissed ||
    !isEdlinkUser ||
    isEdlinkConnected ||
    location.pathname === "/profiles/me"
  ) {
    return null;
  }

  const handleDismiss = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDismissed(true);
  };

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    window.location.href =
      "https://ed.link/sso/login?client_id=6d462dde-5ceb-4239-8aa1-0a2a3e36cca3&redirect_uri=https://api.madlen.io/api/edlink/oauth/callback&state=" +
      teacherId +
      "," +
      window.location.origin +
      "/profiles/me?callback=true";
  };

  return (
    <div
      className="fixed bottom-4 right-4 bg-gradient-to-r from-blue-500 to-blue-600 p-2 rounded-lg shadow-xl border border-blue-400 dark:border-blue-500 max-w-sm cursor-pointer select-none hover:opacity-95 transition-opacity duration-200"
      onClick={handleClick}
    >
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-3">
          <span className="p-2 bg-blue-100 dark:bg-blue-900/50 rounded-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-blue-600 dark:text-blue-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 10V3L4 14h7v7l9-11h-7z"
              />
            </svg>
          </span>
          <Text variant="p" className="text-white font-medium text-lg">
            {t("common.connectEdlink")}
          </Text>
        </div>
        <div className="flex justify-end">
          <Button
            onClick={handleDismiss}
            variant="outline"
            size="sm"
            className="bg-white/10 text-white hover:bg-white/20 border-white/20"
          >
            {t("common.dontShowAgain")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EdlinkReminder;
